import i18next from 'i18next';
import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { GET_CREDIT_SCORE } from '../../../axios/appiendPoints';
import { axiosInstanceNext } from '../../../axios/axios';
import '../../../css/joinLoyalty.css';
import '../../../css/loyaltycards.css';
import { RED_RIGHT_ARROW } from '../../../paths/defaultImage';
import { getSessionItem } from '../../../webStorage/sessionStorage';
import SuspenseWrapper from '../../common/suspenseWrapper';
import LazyImage from '../../common/lazyLoad';
const LoyaltyPopup = lazy(() =>
  import(/* webpackChunkName:"LoyaltyPopup"*/ '../../popUp/loyaltyPopup')
);

export default function JoinLoyalty({
  menu,
  img,
  align,
  containerStyles = '',
  contentStyles = '',
  showMinLoyaltyForCurrentOrderType = true,
}) {
  const { t } = useTranslation();
  let [isLoyalty, setIsLoyaty] = useState(false);
  let [modal, setModal] = useState(false);
  let [loyalty, setLoyalty] = useState({ text: '', value: 0 });
  let [expiryData, setExpiryData] = useState(null);
  const currentSymbol = useSelector((state) => state.restSetting?.Setting?.curr_sym);
  const isSecondIteration = getSessionItem('add_more');
  const cartMinLoyaltyFromRedux_text = useSelector(
    (state) => state.cart.cartBill?.amt_req_earn_loyalty_text
  );
  const cartMinLoyaltyFromRedux = useSelector((state) => state.cart.cartBill?.amt_req_earn_loyalty);

  const restarantLoyaltyFromRedux = useSelector(
    (state) => state.restSetting?.Setting?.loyalty_settings_v2
  );
  const restaurant = useSelector((state) => state.restSetting?.Setting);

  const { id: res_id, name } = restaurant;
  const fetchLoyaltyCashback = () => {
    setIsLoyaty(false);
    axiosInstanceNext
      .get(
        GET_CREDIT_SCORE +
          '/user/' +
          localStorage.getItem('user_id') +
          '?pmt_channel=loyalty_cashback' +
          '&restaurant_ids=' +
          res_id
      )
      .then((response) => {
        setLoyalty({
          text: response?.data?.data?.total_credits_text || '',
          value: response?.data?.data?.total_credits || 0,
        });
        setExpiryData(response?.data?.data?.expiry_data);
        setIsLoyaty(true);
      })
      .catch((err) => {
        console.error(err.message);
        setIsLoyaty(true);
      });
  };
  useEffect(() => {
    fetchLoyaltyCashback();
  }, [res_id]);
  const openModal = () => {
    setModal(true);
  };
  const close = () => {
    setModal(false);
  };
  const getLoyaltyBannerText = () => {
    if (loyalty?.value === 0 && (!isSecondIteration || !showMinLoyaltyForCurrentOrderType)) {
      return `${t('order_earn')} ${restarantLoyaltyFromRedux?.cashback}% ${t('loyalty_cashback')}*`;
    }

    if (isSecondIteration && showMinLoyaltyForCurrentOrderType) {
      if (cartMinLoyaltyFromRedux !== 0) {
        return `${t('order_for')} ${currentSymbol} ${cartMinLoyaltyFromRedux_text} ${t(
          'more_to_earn'
        )} ${restarantLoyaltyFromRedux?.cashback}% ${t('loyalty_cashback')} ${t('on_this_order')}*`;
      }
      return `${t('order_earn')} ${restarantLoyaltyFromRedux?.cashback}% ${t('loyalty_cashback')}*`;
    }

    return `${t('redeem')} ${currentSymbol} ${loyalty?.text} ${t('loyalty_cashback')}`;
  };

  const getLoyaltyBannerValidText = () => {
    if (loyalty?.value === 0 && (!isSecondIteration || !showMinLoyaltyForCurrentOrderType)) {
      return (
        <div className='fs-10 fw-500 orderStatus-text w-100'>
          {t('valid_on')}
          {i18next.resolvedLanguage === 'id'
            ? restarantLoyaltyFromRedux?.order_types
                ?.filter((order_types) => !order_types.includes('DLEV'))
                .map((order_types, order_types_index) => (
                  <span key={order_types_index}>
                    {order_types_index ? ', ' : ' '}{' '}
                    {restarantLoyaltyFromRedux.order_type_names[order_types]}
                  </span>
                ))
            : restarantLoyaltyFromRedux?.order_types?.map((type, index) => (
                <span key={index}>
                  {''} {restarantLoyaltyFromRedux.order_type_names[type]}
                  {index > restarantLoyaltyFromRedux?.order_types?.length - 2 ? (
                    ''
                  ) : index < restarantLoyaltyFromRedux?.order_types?.length - 2 ? (
                    <span>, </span>
                  ) : (
                    <span> & </span>
                  )}
                </span>
              ))}
        </div>
      );
    }
    return null;
  };

  return (
    <>
      {restarantLoyaltyFromRedux &&
      restarantLoyaltyFromRedux?.cashback !== 0 &&
      restarantLoyaltyFromRedux?.is_loyalty_active ? (
        <div
          className={`d-flex flex-column ${containerStyles}`}
          onClick={menu ? openModal : undefined}>
          <div className={`d-flex lh-3 gap-2 align-items-center loyaltyBanner ${contentStyles}`}>
            {align === 'left' && <LazyImage src={img} alt='golden wallet' height={23} width={25} />}
            <div className=' d-flex flex-column '>
              {!menu && isLoyalty && (
                <div className={`fs-14 fw-600 text-white`}>
                  {`${t('order_earn')} ${restarantLoyaltyFromRedux?.cashback}% ${t(
                    'loyalty_cashback'
                  )} ${t('on_this_order')}*`}
                </div>
              )}
              {menu && (
                <div
                  className={`d-flex flex-column ${
                    loyalty?.value === 0 ? 'gap-1' : 'gap-2'
                  } text-white`}>
                  <div className='fs-14 fw-700 loyalty-cashback-text'>{getLoyaltyBannerText()}</div>
                  {getLoyaltyBannerValidText()}
                  <div className='learn-how'>
                    {t('how_it_works')}{' '}
                    <LazyImage src={RED_RIGHT_ARROW} width='11' alt='RedArrow' />
                  </div>
                </div>
              )}
            </div>
            {align === 'right' && (
              <LazyImage src={img} alt='golden wallet' height={65} width={65} />
            )}
          </div>
        </div>
      ) : null}
      {modal ? (
        <SuspenseWrapper>
          <LoyaltyPopup close={close} expiryData={expiryData}></LoyaltyPopup>
        </SuspenseWrapper>
      ) : null}
    </>
  );
}
